<template>
   <confirm-dialog 
    :show="show"
    :message="message"
    @accept="destroy"
    @close="$emit('close')">
  </confirm-dialog>
</template>

<script>
import ConfirmDialog from '@/components/global/ConfirmDialog';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  components: {
    ConfirmDialog,
  },
  methods: {
    destroy() {
      this.axios.delete(this.url).then(() => {
        this.$emit('deleted');
      }).catch(() => {});
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/global/DeleteDialog2.vue